import React, { useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  createCoachingPerformance,
  getCoachingPerformanceStudentForBatch,
} from "../../actions/CoachingPerformance.action";
import { years } from "../../constants/MonthsAndYears";
import {
  getTermOptions,
  getTermLabel,
  getTermCountOptions,
} from "../../utils/coachingPerformance";
import styles from "./AddCoachingPerformanceForm.module.css";

const isValidTotalMark = (value) => {
  const parsedValue = parseFloat(value);
  return Number.isFinite(parsedValue) && parsedValue > 0;
};

const isValidGainedMark = (value) => {
  const parsedValue = parseFloat(value);
  return Number.isFinite(parsedValue) && parsedValue >= 0;
};

const AddCoachingPerformanceForm = ({
  extra,
  grades,
  getCoachingPerformanceStudentForBatch,
  createCoachingPerformance,
}) => {
  const [grade, setGrade] = useState("");
  const [batch, setBatch] = useState("");
  const [shift, setShift] = useState("");
  const [termCount, setTermCount] = useState("");
  const [term, setTerm] = useState("");
  const [total, setTotal] = useState("100");
  const [totalShow, setTotalShow] = useState("100");

  const [year, setYear] = useState(new Date().getFullYear().toString());
  const [loading, setLoading] = useState(false);

  const [students, setStudents] = useState(null);

  const updateStudentField = (studentId, field, value) => {
    setStudents(
      students.map((student) =>
        student.id === studentId
          ? {
              ...student,
              [field]: value,
            }
          : student
      )
    );
  };

  const selectHandeler = async () => {
    if (!isValidTotalMark(total)) {
      toast.error("Please enter total mark!");
      return;
    }
    if (!termCount) {
      toast.error("Please select term count!");
      return;
    }
    if (!term) {
      toast.error("Please select term type!");
      return;
    }
    const list = await getCoachingPerformanceStudentForBatch(
      year,
      term,
      batch,
      termCount
    );
    if (!list) {
      return;
    }
    setStudents(
      list.map((l) => ({
        total,
        gained: "0",
        id: l.id,
        studentId: l.id,
        uid: l.uid,
        name: l.name,
        phone: l.phone,
      }))
    );
    setTotalShow(total);
  };

  const submitHandeler = async () => {
    if (!students || students.length === 0) {
      toast.error("Please select at least one student!");
      return;
    }

    const invalidStudent = students.find(
      (student) =>
        !isValidTotalMark(student.total) || !isValidGainedMark(student.gained)
    );

    if (invalidStudent) {
      toast.error(
        `Please enter valid total and gained marks for ${invalidStudent.name}.`
      );
      return;
    }

    const normalizedStudents = students.map((student) => ({
      ...student,
      total: parseFloat(student.total),
      gained: parseFloat(student.gained),
    }));

    setLoading(true);
    let check = await createCoachingPerformance(term, year, normalizedStudents);
    if (check === true) {
      setStudents(null);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const deleteHandeler = (id) => {
    setStudents([...students.filter((st) => st.id !== id)]);
  };

  // Get term options based on selected term count
  const termOptions = termCount ? getTermOptions(parseInt(termCount)) : [];

  return (
    <Container>
      <Card bg="white" text="dark" className={`crd shadow`}>
        <Card.Body>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="grade" className="d-block">
                  Class
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setBatch("");
                  setShift("");
                  setGrade(e.target.value);
                }}
              >
                <option value={""}>Select Class</option>
                {grades &&
                  grades.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
              </Form.Select>
            </Col>
            {grade !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="shift" className="d-block">
                    Shift
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setBatch("");
                    setShift(e.target.value);
                  }}
                >
                  <option value={""}>Select Shift</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .shifts.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="batch" className="d-block">
                    Batch
                  </label>
                </div>
                <Form.Select onChange={(e) => setBatch(e.target.value)}>
                  <option value={""}>Select Batch</option>
                  {grades
                    .filter((grd) => grd.id === parseInt(grade))[0]
                    .batches.filter((bt) => bt.shiftId === parseInt(shift))
                    .map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            {grade !== "" && shift !== "" && batch !== "" && total ? (
              <Col
                md={3}
                className="d-flex jsutify-content-end align-items-end py-3"
              >
                <Button
                  onClick={selectHandeler}
                  variant="primary"
                  type="submit"
                  className="btn_primary"
                >
                  Select
                </Button>
              </Col>
            ) : (
              <></>
            )}
          </Row>
          <Row>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="termCount" className="d-block">
                  Term Count
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setTermCount(e.target.value);
                  setTerm(""); // Reset term when term count changes
                }}
                id="termCount"
                name="termCount"
                value={termCount}
              >
                <option value={""}>Select Term Count</option>
                {getTermCountOptions().map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            {termCount !== "" ? (
              <Col md={3} className="py-3">
                <div className="d-flex justify-content-between align-items-center pb-2">
                  <label htmlFor="term" className="d-block">
                    Term Type
                  </label>
                </div>
                <Form.Select
                  onChange={(e) => {
                    setTerm(e.target.value);
                  }}
                  id="term"
                  name="term"
                  value={term}
                >
                  <option value={""}>Select Term Type</option>
                  {termOptions.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            ) : (
              <></>
            )}
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="year" className="d-block">
                  Year
                </label>
              </div>
              <Form.Select
                onChange={(e) => {
                  setYear(e.target.value);
                }}
                id="year"
                name="year"
                value={year}
              >
                {years.map((item, i) => (
                  <option key={i} value={`${item}`}>
                    {item}
                  </option>
                ))}
              </Form.Select>
            </Col>
            <Col md={3} className="py-3">
              <div className="d-flex justify-content-between align-items-center pb-2">
                <label htmlFor="total" className="d-block">
                  Total Mark
                </label>
              </div>
              <Form.Control
                name="total"
                type="number"
                step={0.01}
                value={total}
                onChange={(e) => setTotal(e.target.value)}
                className={`w-100`}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {students ? (
        <Card bg="white" text="dark" className={`crd shadow mt-4`}>
          <Card.Body>
            <h1 className="fs-4 fw-normal py-3">
              Fill the student marks{" "}
              <b>
                {extra && extra?.term && extra?.termCount && extra?.year
                  ? `for ${getTermLabel(parseInt(extra.termCount), parseInt(extra.term))} ${extra.year}`
                  : ""}
              </b>{" "}
              and <b> Total Mark: {totalShow}</b>
            </h1>
            <Row>
              <Col
                md={1}
                className="d-flex align-items-center justify-content-center"
              >
                <span className="d-block fw-bold">Roll</span>
              </Col>
              <Col md={4} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Name</span>
              </Col>
              <Col md={3} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Total Mark</span>
              </Col>
              <Col md={3} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Gained Mark</span>
              </Col>

              <Col md={1} className="d-flex align-items-center ">
                <span className="d-block fw-bold">Delete</span>
              </Col>
            </Row>
            <hr />
            {students.map((student) => (
              <React.Fragment key={student.id}>
                <Row>
                  <Col
                    md={1}
                    className="d-flex align-items-center justify-content-center"
                  >
                    <span className="d-block">
                      <span className="fw-bold">{student.uid}</span>
                    </span>
                  </Col>
                  <Col md={4} className="d-flex align-items-center">
                    <span className="d-block">
                      <span className="fw-bold">{student.name}</span>
                    </span>
                  </Col>

                  <Col md={3}>
                    <InputGroup className=" d-flex flex-column">
                      <Form.Control
                        placeholder="Total mark..."
                        name="total"
                        type="number"
                        step={0.01}
                        required
                        className={`${styles.input} w-100`}
                        value={student.total}
                        onChange={(e) =>
                          updateStudentField(student.id, "total", e.target.value)
                        }
                      />
                    </InputGroup>
                  </Col>
                  <Col md={3}>
                    <InputGroup className=" d-flex flex-column">
                      <Form.Control
                        placeholder="Gained mark..."
                        name="gained"
                        type="number"
                        step={0.01}
                        required
                        className={`${styles.input} w-100`}
                        value={student.gained}
                        onChange={(e) =>
                          updateStudentField(student.id, "gained", e.target.value)
                        }
                      />
                    </InputGroup>
                  </Col>

                  <Col md={1} className="d-flex align-items-center">
                    <span
                      className={`text-danger fs-4  ${styles.del}`}
                      onClick={() => deleteHandeler(student.id)}
                    >
                      <BiTrash />
                    </span>
                  </Col>
                </Row>
                <hr />
              </React.Fragment>
            ))}
            <Row>
              <Col md={6}></Col>
            </Row>
            <Button
              onClick={submitHandeler}
              variant="primary"
              className="btn_primary"
              disabled={loading}
            >
              {loading ? "Loading..." : "Submit"}
            </Button>
          </Card.Body>
        </Card>
      ) : (
        <></>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => ({
  extra: state.coachingPerformance.extra,
});

export default connect(mapStateToProps, {
  getCoachingPerformanceStudentForBatch,
  createCoachingPerformance,
})(AddCoachingPerformanceForm);
